import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function UKNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;

        if (!value) {
            return null;
        }

        const startsWithZero = value.toString().startsWith('0');
        const startsWithPlus44 = value.toString().startsWith('+44');
        const matchUKNumberPattern = new RegExp(/^(0\d*|\+44\d*)$/).test(value);

        const startsWithZeroTooLong = startsWithZero && value.length > 11;
        const startsWithPlus44TooLong = startsWithPlus44 && value.length > 13;

        if (!startsWithZero && !startsWithPlus44) return { ukNumber: true };
        if (!matchUKNumberPattern) return { invalid: true };
        if (startsWithPlus44TooLong) return { startsWithPlus44TooLong: true };
        if (startsWithZeroTooLong) return { startsWithZeroTooLong: true };
        return null;
    };
}
